import * as React from 'react'

import { Box, Colors, Icon, MediumIcon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  onClick?: () => void
  icon?: MediumIcon | false
  iconColor?: Colors
}

const TaskButton = ({
  onClick,
  icon,
  iconColor = 'grey700',
  children,
}: React.PropsWithChildren<Props>) => {
  const [hover, setHover] = React.useState(false)

  return (
    <Box
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      paddingX="s24"
      paddingY="s8"
      cursor="pointer"
      background={hover ? 'grey200' : 'grey100'}
      border={{ all: { style: 'dashed', width: 's2', color: 'grey400' } }}
      style={{ borderSpacing: '240px' }}
      borderRadius={{ all: 'abs008' }}
      justifyContent="spaceBetween"
      alignItems="center"
    >
      <Box flexDirection="row" alignItems="center" gap="s6" justifyContent="center">
        {icon && <Icon.Medium icon={icon} color={iconColor} />}
        <Text.Normal size="200" weight="medium" color="grey800">
          {children}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default TaskButton
